export default "__VITE_ASSET__ztRzI_nn__"